import { render, staticRenderFns } from "./OrgSchoolReportList.vue?vue&type=template&id=4ac89a1e&scoped=true&"
import script from "./OrgSchoolReportList.vue?vue&type=script&lang=js&"
export * from "./OrgSchoolReportList.vue?vue&type=script&lang=js&"
import style0 from "./OrgSchoolReportList.vue?vue&type=style&index=0&id=4ac89a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac89a1e",
  null
  
)

export default component.exports